import { t } from 'i18next';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { APIHeader } from '../..';
import { fetchFilesFromCreator } from '../../helpers/filesHelpers/fetchFiles';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import { getDownloadLink } from '../../utils';
import UploadedFiles from './UploadedFiles';
import { onDownloadFileFromCreator } from '../../helpers/filesHelpers/downloadFiles';

function CreatorFiles(props) {
  const [creatorDocs, setCreatorDocs] = React.useState([]);
  const dispatch = useDispatch();
  const { apiConfig, pecrId } = props;

  const payload = {
    url: apiConfig.uiURL,
    pecrId: pecrId,
  };

  useEffect(() => {
    if (!pecrId || !apiConfig.uiURL) return;
    //To fetch the files uploaded by Creator on Overview page
    async function fetchDocs() {
      try {
        const docs = await fetchFilesFromCreator(apiConfig.uiURL, pecrId);
        setCreatorDocs(docs);
      } catch (error) {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      }
    }
    fetchDocs();
  }, [pecrId, apiConfig.uiURL]);
  return (
    <UploadedFiles
      title="Doc_uploaded_by_Creator"
      docs={creatorDocs}
      payload={payload}
      downloadFunction={onDownloadFileFromCreator}
    />
  );
}

export default CreatorFiles;
